module.exports = __webpack_public_path__ + "static/media/gif.a63db3cf.gif";